export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-line"></i>
              实时追踪 · 全网首发
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              91吃瓜爆料网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">
                吃瓜群众专属入口
              </span>
            </h1>

            <p className="text-sm md:text-base text-primary-600 font-medium mb-5">
              一手爆料 · 深度追踪 · 全网首发
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              91吃瓜爆料网是国内领先的娱乐八卦资讯聚合平台，为吃瓜群众提供最新、最全、最快的明星爆料与娱乐圈内幕。每日实时追踪全网热点事件，深度挖掘台前幕后不为人知的真相。无论你是资深吃瓜群众还是刚刚入圈的新手，这里都是你获取第一手娱乐资讯的最佳入口。当前站内正热议多条重磅爆料，快来加入百万吃瓜大军！
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading text-primary-600">50+</div>
                <div className="text-xs text-foreground-500">全网信源监控</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading text-primary-600">200+</div>
                <div className="text-xs text-foreground-500">日均更新爆料</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-heading text-primary-600">百万</div>
                <div className="text-xs text-foreground-500">吃瓜群众在线</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-eye-line"></i>
                立即吃瓜
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-700 rounded-md font-medium text-sm hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                最新爆料
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] md:aspect-[5/4] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20art%20illustration%2C%20abstract%20crowd%20of%20people%20with%20smartphones%20surrounded%20by%20floating%20news%20bubbles%20and%20hot%20topic%20icons%2C%20warm%20coral%20red%20and%20golden%20amber%20gradient%20background%2C%20energetic%20editorial%20style%2C%20geometric%20abstract%20shapes%2C%20clean%20modern%20composition%2C%20trending%20social%20media%20vibe&width=800&height=700&seq=hero-main-visual&orientation=landscape"
                alt="91吃瓜爆料网 - 吃瓜群众专属娱乐八卦资讯平台主视觉"
                title="91吃瓜爆料网 - 吃瓜群众专属入口"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex items-center gap-3 mt-3 justify-center lg:justify-start">
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-shield-check-line text-accent-600"></i>
                安全直达
              </span>
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-time-line text-accent-600"></i>
                7×24更新
              </span>
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-group-line text-accent-600"></i>
                百万瓜友
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}